<mat-card appearance="outlined">
  <div class="row">
    <div class="col">
      <p>
        <ng-container>
          <strong [innerText]="title"></strong>
        </ng-container>
      </p>
      <div class="d-flex justify-content-center flex-column flex-md-row">
        <ng-container>
          <button class="me-0 me-md-2 mb-2 mb-md-0" mat-stroked-button (click)="validar()">
            <mat-icon>done</mat-icon>
            Si
          </button>
        </ng-container>
        <button mat-stroked-button (click)="rechazar()">
          <mat-icon>close</mat-icon>
          No
        </button>
      </div>
    </div>
  </div>
</mat-card>